var map = {
	"./abz-logo.png": "8cf7",
	"./beavers/beavers.png": "5987",
	"./beavers/correct.png": "afa5",
	"./beavers/wrong.png": "978d",
	"./difficulty/difficulty_1.png": "d07c",
	"./difficulty/difficulty_2.png": "1e44",
	"./difficulty/difficulty_3.png": "8fbe",
	"./ethz-logo.svg": "5dd7",
	"./graphs/edges1/e_1_10_g.png": "beb3",
	"./graphs/edges1/e_1_10_r.png": "85ece",
	"./graphs/edges1/e_1_11_g.png": "3aeb",
	"./graphs/edges1/e_1_11_r.png": "ab5e",
	"./graphs/edges1/e_1_12_g.png": "9e54",
	"./graphs/edges1/e_1_12_r.png": "a3c2",
	"./graphs/edges1/e_1_1_g.png": "2f7f",
	"./graphs/edges1/e_1_1_r.png": "eee0",
	"./graphs/edges1/e_1_2_g.png": "b6dd",
	"./graphs/edges1/e_1_2_r.png": "fc32",
	"./graphs/edges1/e_1_3_g.png": "1b99",
	"./graphs/edges1/e_1_3_r.png": "91fa",
	"./graphs/edges1/e_1_4_g.png": "5ae3",
	"./graphs/edges1/e_1_4_r.png": "b6a2",
	"./graphs/edges1/e_1_5_g.png": "25c2",
	"./graphs/edges1/e_1_5_r.png": "9660",
	"./graphs/edges1/e_1_6_g.png": "c1b6",
	"./graphs/edges1/e_1_6_r.png": "d148",
	"./graphs/edges1/e_1_7_g.png": "c195",
	"./graphs/edges1/e_1_7_r.png": "4790",
	"./graphs/edges1/e_1_8_g.png": "51a7",
	"./graphs/edges1/e_1_8_r.png": "2531",
	"./graphs/edges1/e_1_9_g.png": "d5eb",
	"./graphs/edges1/e_1_9_r.png": "16cd",
	"./graphs/edges2/e_2_10_g.png": "8a37",
	"./graphs/edges2/e_2_10_r.png": "6b42",
	"./graphs/edges2/e_2_11_g.png": "ede5",
	"./graphs/edges2/e_2_11_r.png": "065b",
	"./graphs/edges2/e_2_12_g.png": "b456",
	"./graphs/edges2/e_2_12_r.png": "fb7b",
	"./graphs/edges2/e_2_13_g.png": "2bdb",
	"./graphs/edges2/e_2_13_r.png": "3ce9",
	"./graphs/edges2/e_2_14_g.png": "9fe0",
	"./graphs/edges2/e_2_14_r.png": "11b1",
	"./graphs/edges2/e_2_15_g.png": "a398",
	"./graphs/edges2/e_2_15_r.png": "727f",
	"./graphs/edges2/e_2_16_g.png": "28e0",
	"./graphs/edges2/e_2_16_r.png": "267f",
	"./graphs/edges2/e_2_17_g.png": "b7e5",
	"./graphs/edges2/e_2_17_r.png": "236f",
	"./graphs/edges2/e_2_18_g.png": "2395",
	"./graphs/edges2/e_2_18_r.png": "a04b",
	"./graphs/edges2/e_2_19_g.png": "1aa2",
	"./graphs/edges2/e_2_19_r.png": "4e8e",
	"./graphs/edges2/e_2_1_g.png": "304c",
	"./graphs/edges2/e_2_1_r.png": "9670",
	"./graphs/edges2/e_2_20_g.png": "ecdf",
	"./graphs/edges2/e_2_20_r.png": "4848",
	"./graphs/edges2/e_2_2_g.png": "9edb",
	"./graphs/edges2/e_2_2_r.png": "b83c",
	"./graphs/edges2/e_2_3_g.png": "b4d8",
	"./graphs/edges2/e_2_3_r.png": "74d7",
	"./graphs/edges2/e_2_4_g.png": "e97d",
	"./graphs/edges2/e_2_4_r.png": "8bad",
	"./graphs/edges2/e_2_5_g.png": "ce21",
	"./graphs/edges2/e_2_5_r.png": "0311",
	"./graphs/edges2/e_2_6_g.png": "7e46",
	"./graphs/edges2/e_2_6_r.png": "7fa8",
	"./graphs/edges2/e_2_7_g.png": "a235",
	"./graphs/edges2/e_2_7_r.png": "b0f2",
	"./graphs/edges2/e_2_8_g.png": "7c05",
	"./graphs/edges2/e_2_8_r.png": "20b0",
	"./graphs/edges2/e_2_9_g.png": "2ab1",
	"./graphs/edges2/e_2_9_r.png": "00c3",
	"./graphs/edges3/e_3_10_g.png": "21a9",
	"./graphs/edges3/e_3_10_r.png": "850e",
	"./graphs/edges3/e_3_11_g.png": "cdc3",
	"./graphs/edges3/e_3_11_r.png": "301f",
	"./graphs/edges3/e_3_12_g.png": "76f4",
	"./graphs/edges3/e_3_12_r.png": "db38",
	"./graphs/edges3/e_3_13_g.png": "9c81",
	"./graphs/edges3/e_3_13_r.png": "371c",
	"./graphs/edges3/e_3_14_g.png": "7f17",
	"./graphs/edges3/e_3_14_r.png": "b548",
	"./graphs/edges3/e_3_15_g.png": "ce218",
	"./graphs/edges3/e_3_15_r.png": "f1a9",
	"./graphs/edges3/e_3_16_g.png": "1b53",
	"./graphs/edges3/e_3_16_r.png": "c7ec",
	"./graphs/edges3/e_3_17_g.png": "7543",
	"./graphs/edges3/e_3_17_r.png": "3c78",
	"./graphs/edges3/e_3_18_g.png": "ff7c",
	"./graphs/edges3/e_3_18_r.png": "d5ca",
	"./graphs/edges3/e_3_19_g.png": "092c",
	"./graphs/edges3/e_3_19_r.png": "672c",
	"./graphs/edges3/e_3_1_g.png": "a359",
	"./graphs/edges3/e_3_1_r.png": "3d2f",
	"./graphs/edges3/e_3_20_g.png": "863d",
	"./graphs/edges3/e_3_20_r.png": "71ee",
	"./graphs/edges3/e_3_21_g.png": "c5c0",
	"./graphs/edges3/e_3_21_r.png": "3042",
	"./graphs/edges3/e_3_22_g.png": "2562",
	"./graphs/edges3/e_3_22_r.png": "daf8",
	"./graphs/edges3/e_3_23_g.png": "b33d",
	"./graphs/edges3/e_3_23_r.png": "4782",
	"./graphs/edges3/e_3_24_g.png": "22ec",
	"./graphs/edges3/e_3_24_r.png": "dbd2",
	"./graphs/edges3/e_3_25_g.png": "9c36",
	"./graphs/edges3/e_3_25_r.png": "0ef3",
	"./graphs/edges3/e_3_26_g.png": "b7ed",
	"./graphs/edges3/e_3_26_r.png": "3195",
	"./graphs/edges3/e_3_27_g.png": "e044",
	"./graphs/edges3/e_3_27_r.png": "cd9e",
	"./graphs/edges3/e_3_28_g.png": "9bd6",
	"./graphs/edges3/e_3_28_r.png": "4ece",
	"./graphs/edges3/e_3_2_g.png": "20a4",
	"./graphs/edges3/e_3_2_r.png": "0e30",
	"./graphs/edges3/e_3_3_g.png": "aac1",
	"./graphs/edges3/e_3_3_r.png": "c2e1",
	"./graphs/edges3/e_3_4_g.png": "1655",
	"./graphs/edges3/e_3_4_r.png": "1514",
	"./graphs/edges3/e_3_5_g.png": "acd9",
	"./graphs/edges3/e_3_5_r.png": "eca8",
	"./graphs/edges3/e_3_6_g.png": "b92b",
	"./graphs/edges3/e_3_6_r.png": "d957",
	"./graphs/edges3/e_3_7_g.png": "6611",
	"./graphs/edges3/e_3_7_r.png": "914b",
	"./graphs/edges3/e_3_8_g.png": "5ddc",
	"./graphs/edges3/e_3_8_r.png": "8cee",
	"./graphs/edges3/e_3_9_g.png": "f825",
	"./graphs/edges3/e_3_9_r.png": "1e54",
	"./graphs/weights1.png": "2b27",
	"./graphs/weights2.png": "ff9a",
	"./graphs/weights3.png": "05ef",
	"./icons/lightbulb.png": "940e",
	"./icons/trashcan.png": "181f",
	"./icons/undo.png": "c4d2",
	"./placeholder.jpg": "90ab",
	"./weight.png": "838b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";